/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 11.02.21
 *
 */
import AnalyticsManager from './analytics'
let analyticsManager = new AnalyticsManager()


const PADDLE_VENDOR_ID = 101378
const PADDLE_EARLY_ADOPTER_PLAN_ID = 569425

$(function() {

    if(window.Paddle){
        Paddle.Setup({
            vendor: PADDLE_VENDOR_ID ,
            eventCallback: data => {
                let event = new CustomEvent("paddleCheckoutFlow", {detail: data})
                document.dispatchEvent(event);
            }
        });

        document.addEventListener("paddleCheckoutFlow", (event) => {
            let data = event.detail
            // console.log("paddleCheckoutFlow: ", data)
            analyticsManager.trackEvent("Checkout flow", {
                category: "Billing page",
                event_name: data.event,
                label: data.eventData ? (data.eventData.payment_method || data.eventData.error) : undefined
            })
        })
    }




    function openEarlyAdopterCheckout() {
        if(window.Paddle){
            Paddle.Checkout.open({
                product: PADDLE_EARLY_ADOPTER_PLAN_ID,
                successCallback: data => {
                    console.log(data);
                    alert("Thanks for joining the Early Bird program!. We'll get back to you shortly.");
                },
            });
        }
    }

    window.openEarlyAdopterCheckout = openEarlyAdopterCheckout



    let yearsCoachingInput = $("#years_coaching")
    let savingContainer = $("#saving_container")
    let savingsValue = $("#savings_value")
    let savingsValue2 = $("#savings_value2")

    let savingsValueYears = $("#savings_value_years")

    savingContainer.hide()
    yearsCoachingInput.on("change paste keyup", function() {
        let yearsCoaching = Math.min(100, Math.max(0, $(this).val()));
        recalculateSavings(yearsCoaching);
    });

    yearsCoachingInput.val(5)
    recalculateSavings(5);

    function recalculateSavings(yearsCoaching){

        if(yearsCoaching > 0){
            let firstYearSavings = 19*12//9*6 + 19*6
            let savingsNumber =  Math.trunc((89 * yearsCoaching * 12) - (firstYearSavings + (yearsCoaching - 1) * 19 * 12))
            savingsValue.text("$" + savingsNumber)
            savingsValue2.text("$" + savingsNumber)
            savingsValueYears.text(yearsCoaching == 1 ? "year" : `${yearsCoaching} years`)
            savingContainer.show()
        } else {
            savingContainer.hide()
        }

    }

});
